import React from "react"

function Wyoming() {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="84" height="80" viewBox="0 0 84 80">
            <path d="M80.16 35.12l-0.4-28.88-36.64-0.32-35.2-1.84-3.92 57.84 37.36 1.84 39.12 0.32z"></path>
        </svg>
    )
}

export default Wyoming